import { render, staticRenderFns } from "./waitPage.vue?vue&type=template&id=7617b740"
import script from "./waitPage.vue?vue&type=script&lang=js"
export * from "./waitPage.vue?vue&type=script&lang=js"
import style0 from "./waitPage.vue?vue&type=style&index=0&id=7617b740&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports